import {
  InsuranceMonitorConfiguration,
  RequirementDefinition,
  SharedFileRequestConfiguration
} from "@wingspanhq/wingspan-api-sdk";

import { selectorPolicyTypesFromSettings } from "../../Requirements/modules/InsuranceCoverage/selectors/selectorPolicyTypesFromSettings";
import { RequirementDefinitionSettingsItem } from "../types";

import { getRequirementDefinitionTemplateByParams } from "./getRequirementDefinitionTemplateByParams";

export const getRequirementDefinitionTemplate = (
  requirementDefinition: RequirementDefinition,
  settingsItem: RequirementDefinitionSettingsItem,
  strict: boolean = false
) => {
  return getRequirementDefinitionTemplateByParams({
    contextType: (settingsItem as SharedFileRequestConfiguration)?.contextType,
    policyType: selectorPolicyTypesFromSettings(
      settingsItem as InsuranceMonitorConfiguration
    ),
    strict,
    type: requirementDefinition.type!
  });
};
